import { z } from "zod";

export const notificationTypeSchema = z.enum([
  "NEW_DRIVER_CREATED",
  "DRIVER_ROTATION_REQUEST",
  "NO_DRIVER",
  "MILEAGE_OVER_15_PERCENT_COMPARED_TO_PLANNING",
  "VEHICLE_OVER_DRIVING_MONTHLY",
  "VEHICLE_UNDER_DRIVING_MONTHLY",
  "VEHICLE_REQUIRING_TECHNICAL_INSPECTION",
  "TIRE_PRESSURE_ALERT",
  "NEXT_MAINTENANCE_ALERT",
  "DASHBOARD_WARNING",
  "SUSPICIOUS_CONSUMPTION_DETECTED",
  "TANK_CAPACITY_REACHED_95_PERCENT",
  "TANK_CAPACITY_REACHED_100_PERCENT",
  "WEEKEND_TRANSACTIONS",
  "VEHICLE_MOVING_AFTER_HOUR_LIMIT",
  "VEHICLE_MOVING_BEFORE_HOUR_LIMIT",
  "VEHICLE_MOVING_ON_WEEKENDS_OR_PUBLIC_HOLIDAYS",
  "VEHICLE_EXCEEDING_SPEED_LIMITS",
  "ECO_DRIVING_SCORE_UNDER_30",
  "LOSS_SCORE_UNDER_30",
  "MISSING_SUPPORTING_DOCUMENT",
  "MISSING_MILEAGE",
  "CARD_EXCEEDED_LIMIT_REACHED",
  "CARD_EXCEEDED_LIMIT_REACHED_80_PERCENT",
  "UNAUTHORIZED_MERCHANT",
  "UNAUTHORIZED_PERIOD",
  "ACCOUNT_BALANCE_UNDER_30",
  "INSUFFICIENT_BALANCE",
  "NEW_TRANSACTION_CREATED",
  "BAD_FUEL",
  "OUT_OF_ZONE",
]);

export const subscriptionRoleSchema = z.enum([
  "OWNER",
  "ADMIN",
  "USER",
  "DEPARTMENT_USER",
]);

export type NotificationType = z.infer<typeof notificationTypeSchema>;
export type SubscriptionRole = z.infer<typeof subscriptionRoleSchema>;

// Use catchall object instead of z.record (.record(z.string(), z.unknown())): toJSONSchema omits propertyNames, which
// fast-json-stringify (Fastify responses) rejects in AJV strict mode.
export const subscriptionParametersUnknownRecordSchema = z
  .object({})
  .catchall(z.unknown())
  .nullable();

export const subscriptionParametersStringOrArrayRecordSchema = z
  .record(z.string(), z.union([z.string(), z.array(z.string()), z.number()]))
  .nullable();
